import AppCommat from '@/pages/AppCommat/Template'
import Points from '@/pages/AppCommat/Points'
import Order from '@/pages/AppCommat/Order'
import Account from '@/pages/AppCommat/Account'
export default {
    path: '/AppCommat',
    component: AppCommat,
    children: [
        {
            path: '',
            name: 'AppCommatPoints',
            component: Points,
        },
        {
            path: ':id/:id1',
            name: 'AppCommatOrder',
            component: Order,
        },
        {
            path: 'account',
            name: 'AppCommatAccount',
            component: Account,
        },
    ]
}


// WEBPACK FOOTER //
// ./src/router/appcommat.js